import { useBizMutation, useBizQuery } from '../../../../../FrontEndReact/src/Core/Hooks/useBizQuery';
import { get, post } from '../../../../../FrontEndReact/src/Core/Services/common';
import { ParticipationStatus } from '../../../../../FrontEndReact/src/Core/Types/event';

const apiPath = 'api/laxhjalpenguardianapproval/';
const QUERYKEY_LH_GUARDIAN_APPROVAL = 'LH_GUARDIAN_APPROVAL';

export type LaxhjalpenGuardianApprovalEvent = {
	eventId: number;
	eventName: string;
	eventStartDateTimeUtc: string;
	eventEndDateTimeUtc: string;
	eventRsvpDateTimeUtc: string;
	eventLocation: string | null;
	studentUserId: number;
	studentName: string;
	guardianUserId: number;
	guardianName: string;
	studentParticipationStatus: ParticipationStatus;
};

type LaxhjalpenGuardianApprovalUpdateRequest = {
	encrypted: string;
	willAttend: boolean;
};

export const useGetGuardianApprovalEvent = (encrypted: string) => {
	const { data, statusState, errorType, errorMessage } = useBizQuery(
		[QUERYKEY_LH_GUARDIAN_APPROVAL, encrypted],
		() => getGuardianApprovalEvent(encrypted),
		encrypted.length > 0
	);

	return {
		data: data ?? null,
		statusState,
		errorType,
		errorMessage,
	};
};

export const useUpdateGuardianApproval = (encrypted: string) => {
	const { mutateAsync, data, statusState, errorType, errorMessage } = useBizMutation(
		(params: { willAttend: boolean }) =>
			updateGuardianApproval({
				encrypted,
				willAttend: params.willAttend,
			}),
		{
			getQueryKeyForInvalidation: () => [[QUERYKEY_LH_GUARDIAN_APPROVAL, encrypted]],
		}
	);

	return {
		updateGuardianApproval: (willAttend: boolean) => mutateAsync({ willAttend }),
		data: data ?? null,
		statusState,
		errorType,
		errorMessage,
	};
};

async function getGuardianApprovalEvent(encrypted: string) {
	return get<LaxhjalpenGuardianApprovalEvent>(`${apiPath}GetEventForGuardianApproval?c=${encrypted}`);
}

async function updateGuardianApproval(request: LaxhjalpenGuardianApprovalUpdateRequest) {
	return post<LaxhjalpenGuardianApprovalEvent>(`${apiPath}UpdateParticipationStatusForStudentByGuardian`, request);
}
